import React from 'react';
import { faBriefcase, faUsers, faAddressBook, faKey, faFileExport } from '@fortawesome/pro-regular-svg-icons';
import { BaseModal } from '../UI/Modal/BaseModal';
import { SidebarModal, type SidebarModalItem } from '../UI/SidebarModal/SidebarModal';
import BusinessInfoContent from './BusinessInfo/BusinessInfoContent';
import UsersContent from './Users/List/UsersContent';
import DirectoryContent from './Directory/List/DirectoryContent';
import ApiKeysContent from './ApiKeys/List/ApiKeysContent';
import DataExportContent from './DataExport/DataExportContent';
import styles from './SettingsModal.module.scss';
import OrganizationsProvider from 'components/Organizations/OrganizationsProvider';
import { isAdminTotalUser } from 'auth/Auth';

interface SettingsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose }) => {
    const sidebarItems: SidebarModalItem[] = [
        {
            id: 'business-info',
            label: 'Business info',
            icon: faBriefcase,
            content: <BusinessInfoContent />
        },
        {
            id: 'users',
            label: 'Users',
            icon: faUsers,
            content: <UsersContent />
        },
        {
            id: 'directory',
            label: 'Directory',
            icon: faAddressBook,
            content: <DirectoryContent />
        },
        {
            id: 'api-keys',
            label: 'API Keys',
            icon: faKey,
            content: <ApiKeysContent />
        },
        // Exports carry client data from every location, so only the organization admin gets them.
        ...(isAdminTotalUser()
            ? [
                  {
                      id: 'data-export',
                      label: 'Data export',
                      icon: faFileExport,
                      content: <DataExportContent />
                  }
              ]
            : [])
    ];

    const prependSidebarContent = (
        <>
            <h2 className={styles.settingsModalTitle}>Settings</h2>
        </>
    );

    return (
        <OrganizationsProvider>
            <BaseModal
                isOpen={isOpen}
                onClose={onClose}
                className={styles.settingsModal}
            >
                <BaseModal.Header
                    showLogo={true}
                    showCloseButton={true}
                />

                <BaseModal.Content className={styles.settingsMainModalContent}>
                    <SidebarModal
                        items={sidebarItems}
                        defaultSelectedId="business-info"
                        className={styles.settingsModalContent}
                        prependSidebarContent={prependSidebarContent}
                    />
                </BaseModal.Content>
            </BaseModal>
        </OrganizationsProvider>
    );
};

export default SettingsModal;
